import { Outlet } from "react-router-dom"

const PWALayout: React.FC = () => {
  return (
    <div className="min-h-screen gradient-bg">
      <Outlet />
    </div>
  )
}

export default PWALayout
